import api from '@/api/index';

const namespaced = true;

const state = {
  checkpointData: [],
  activityData: []
};

const getters = {
  checkpointData: (state) => state.checkpointData,
  activityData: (state) => state.activityData
};

const mutations = {
  SET_CHECKPOINT_DATA: (state, payload) => {
    state.checkpointData = payload;
  },
  SET_ACTIVITIES_DATA: (state, payload) => {
    state.activityData = payload;
  }
};

const actions = {
  async fetchCheckpoints({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        ...payload.params
      }
      const { data } = await api.getCheckpoints(payload.id, params);

      if (data.error) {
        commit('SET_CHECKPOINT_DATA', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_CHECKPOINT_DATA', data.data)
      commit('Table/SET_TOTAL_DATA', data.total ?? 0, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async fetchActivities({ commit }, payload) {
    try {
      const params = {
        ...payload.params
      }
      const { data } = await api.getActivities(payload.id, payload.checkpoint_id, params);

      if (data.error) {
        commit('SET_ACTIVITIES_DATA', [])
        return []
      }

      commit('SET_ACTIVITIES_DATA', data.data)
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async postCheckpoint(_, payload) {
    try {
      const data = await api.postCheckpoint(payload);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async postActivity(_, payload) {
    try {
      const data = await api.postActivity(payload.id, payload.checkpoint_id, payload.form);
      
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async putCheckpoint(_, payload) {
    try {
      await api.putCheckpoint(payload.id, payload.checkpoint_id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },

  async putActivity(_, payload) {
    try {
      await api.putActivity(payload.id, payload.checkpoint_id, payload.activity_id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },

  async deleteCheckpoint(_, payload) {
    try {
      await api.deleteCheckpoint(payload.id, payload.checkpoint_id);
    } catch (error) {
      throw error.data;
    }
  },

  async deleteActivity(_, payload) {
    try {
      await api.deleteActivity(payload.id, payload.checkpoint_id, payload.activity_id);
    } catch (error) {
      throw error.data;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
